import { Component, OnInit, DoCheck, ViewChildren, QueryList, ElementRef, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UsersListService } from "src/app/services/users/users-list.service";
import { QueryParamsForGetUsers } from "src/app/services/api/db3d-api-backend-client.service";
import { UsersListBase } from "./users-list.base";
import { UsersRole } from "src/app/data-models/manage-users/user-role.model";
import { UsersDataFetchMessages } from "src/app/data-models/manage-users/users-data-fetch-messages";
import { NavigationService } from "src/app/services/NavigationService.service";
import { WhiteLabelConfigurationService } from "src/app/services/white-labels/white-label-configuration.service";
import { queryParamsKey, TableHeaderParam } from "src/app/services/users/users-list.constants";
import { Subscription } from "rxjs";

@Component({
  selector: "app-users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"]
})

export class UsersListComponent extends UsersListBase implements OnInit, DoCheck, OnDestroy {

  private idTable = "usersListTable";
  private whiteLabelSubscription: Subscription;
  public usersRoleList: UsersRole[];
  public loadingMsg: string =  UsersDataFetchMessages.loading;
  public errorMsg: string = UsersDataFetchMessages.error;
  public emptyListMsg: string = UsersDataFetchMessages.emptyList;
  public readonly iconPath = "assets/images/icons/arrow-down.png";
  public readonly tableHeadersParameters: TableHeaderParam[]= [
    {
      name: "Email",
      orderingKey: "email"
    },
    {
      name: "Name",
      orderingKey: "full_name"
    },
    {
      name: "Joined",
      orderingKey: "date_joined"
    },
    {
      name: "Role",
      orderingKey: "role__name"
    },
  ];
  public wlSlug: string;

  @ViewChildren("sortingArrow") protected arrows!: QueryList<ElementRef<HTMLElement>>;

  constructor(
    usersListService: UsersListService,
    protected router: Router,
    protected route: ActivatedRoute,
    public navigationService: NavigationService,
    private whiteLabelConfigurationService: WhiteLabelConfigurationService,
  ) {
    super(usersListService, router, route, navigationService);
  }

  ngOnInit(): void {
    this.whiteLabelSubscription = this.whiteLabelConfigurationService.whiteLabelSetupConfiguration.subscribe({
      next: (config) => {
        this.wlSlug = config.slug;
        if(this.wlSlug) this.getUsersRoleList();
      },
    });

    const queryParamsFromUrl: QueryParamsForGetUsers = {
      page: this.route.snapshot.queryParamMap.get(queryParamsKey.page),
      search: this.route.snapshot.queryParamMap.get(queryParamsKey.search),
      ordering: this.route.snapshot.queryParamMap.get(queryParamsKey.sort),
      userRole: this.route.snapshot.queryParamMap.get(queryParamsKey.userRole),
    };

    this.initialize(queryParamsFromUrl);
  }

  ngDoCheck() {
    const ordering = this.route.snapshot.queryParamMap.get(queryParamsKey.sort);
    if (ordering) this.addActiveStyleForSortingArrows(ordering);
  }

  ngOnDestroy(): void {
    if (this.whiteLabelSubscription) this.whiteLabelSubscription.unsubscribe();
  }

  public getUsersRoleList(): void {
    this.usersListService.getUsersRolesList(this.environment.db3dBackendDomain, this.wlSlug).subscribe({
      next: (userRolesResponse) => {
        this.usersRoleList = this.usersListService.mapRoles(userRolesResponse || []);
      },
      error: (err) => {
        if (err?.status === 403) this.router.navigate([this.navigationService.pageNotFound]);
      }
    });
  }

  public goToDetails(userId: number): void {
    this.router.navigate([this.navigationService.adminUsersWithId(userId)], { queryParams: this.route.snapshot.queryParams });
  }

  public isUsersListEmpty(): boolean {
    return !(this.users?.length > 0);
  }

  public changePage(pageNumber: number): void {
    super.changePage(pageNumber);
  }

  public addActiveStyleForSortingArrows(orderingQueryParams: string) {
    return super.addActiveStyleForSortingArrows(orderingQueryParams);
  }

  public findSortingArrow(direction: string, sortBy: string): ElementRef<HTMLElement> | undefined {
    return super.findSortingArrow(direction, sortBy);
  }
}
